"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedFulfillmentShipmentResponseWithCount = exports.mockedFulfillmentShipmentResponse = exports.mockedFulfillmentShipmentUpdateRequest = exports.mockedFulfillmentShipmentCreateRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const date_util_1 = require("../../utils/date.util");
const fulfillment_shipment_product_1 = require("../fulfillment-shipment-product");
const fulfillment_delivery_method_1 = require("../fulfillment-delivery-method");
exports.mockedFulfillmentShipmentCreateRequest = {
  paymentId: 1,
  fulfillmentProducts: [fulfillment_shipment_product_1.mockedFulfillmentShipmentProductCreateRequest],
  orderId: 'ORDER-5555-2020',
  price: 20.5,
  currency: common_interfaces_1.Currency.euro
};
exports.mockedFulfillmentShipmentUpdateRequest = {
  sentAt: date_util_1.takeDaysFromNow(),
  tracking: '123123123'
};
exports.mockedFulfillmentShipmentResponse = {
  id: 1,
  paymentId: 1,
  fulfillmentProducts: [fulfillment_shipment_product_1.mockedFulfillmentShipmentProductResponse],
  fulfillmentDeliveryMethod: fulfillment_delivery_method_1.mockedFulfillmentDeliveryMethodResponse,
  orderId: 'ORDER-5555-2020',
  tracking: '123123123',
  sentAt: date_util_1.takeDaysFromNow(),
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null,
  currency: common_interfaces_1.Currency.euro,
  price: 100,
  dateOfApplication: null,
  dateOrderProcessed: null,
  dateOfDelivery: null,
  daysOnTheWay: null,
  note: '',
  oldId: null
};
exports.mockedFulfillmentShipmentResponseWithCount = {
  items: [exports.mockedFulfillmentShipmentResponse],
  count: 1
};